import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '../../../shared/components/alert/Alert';

interface ProfileEmailFieldProps {
  label: string;
  email: string;
  // eslint-disable-next-line no-unused-vars
  handleEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage: string;
  auth: {
    isHub: boolean;
    authType: string | null;
  };
  hasError?: boolean;
  errorText?: string;
  isAfterSubmit?: boolean;
}

function ProfileEmailField({
  label,
  email,
  handleEmailChange,
  errorMessage,
  auth,
  hasError,
  errorText,
  isAfterSubmit,
}: ProfileEmailFieldProps) {
  const { t } = useTranslation();
  const isAuthorized =
    (!auth.isHub && auth.authType !== null && auth.authType !== 'ChampionHealth') || auth.isHub;

  return (
    <fieldset className={`account_details_container${hasError ? ' error' : ''}`}>
      <legend className="not_logged_label" id="email-legend">
        {hasError && isAfterSubmit && <span className="error-indicator">{t('error')}</span>}
        {label}
        {t('input.label.required')}
      </legend>
      <input
        id="email"
        autoComplete="email"
        className="value_input"
        type="email"
        value={email}
        onChange={handleEmailChange}
        aria-labelledby="email-legend"
        // disable email editing for Hub users and non-Hub users using SSO
        disabled={isAuthorized}
      />
      <Alert
        id="email-error-alert"
        isVisible={hasError}
        message={errorText || errorMessage}
        type="error"
        variant="outline"
        size="md"
      />
    </fieldset>
  );
}

export default ProfileEmailField;
